import IntegrationOverview from '../../../../components/integration-overview/IntegrationOverview';
import FYILogo from '../../../../assets/fyi.png';
import { useFirmContext } from '../../../../providers/FirmProvider';
import { Link } from 'react-router-dom';
import { Group } from '../../../../types/group';
import FYIDocsGroupConfiguration from './FYIDocsGroupConfiguration';
import { useState } from 'react';
import { Button, Input } from '@cimplico/components';
import { useIsActiveSubscription } from '../../../../hooks/use-is-active-subscription';

type GroupFYIDocsIntegrationProps = {
    group: Group;
};
function GroupFYIDocsIntegration({ group }: GroupFYIDocsIntegrationProps): JSX.Element {
    const firm = useFirmContext();
    const { fyi } = group.integrations;
    const allowedFYI = firm.allowedIntegrations?.includes('fyi');
    const [replacing, setReplacing] = useState(false);

    const activeSubscription = useIsActiveSubscription();

    return (
        <IntegrationOverview
            title="FYI"
            description="Pull your documents, clients and groups from FYI."
            active={Boolean(fyi)}
            logo={FYILogo}
            comingSoon={!allowedFYI}
            supportLink="https://learn.cimplico.com/docs/fyi-setup-and-onboarding"
        >
            <div className="mt-2">
                {/* Has the firm setup FYI */}
                {!firm.integrations.fyi ? (
                    <p className="text-sm text-gray-700">
                        Please setup your FYI Docs credentials on the{' '}
                        <Link to={'../../integrations?focusedIntegration=fyi'} className="text-indigo-600 underline">
                            firm settings page
                        </Link>
                        .
                    </p>
                ) : (
                    <div>
                        {/* Configure FYI group */}
                        {(!fyi || replacing) && <FYIDocsGroupConfiguration group={group} onReturn={(): void => setReplacing(false)} />}
                        {fyi && !replacing && (
                            <div className="grid gap-2">
                                <p className="text-sm text-gray-800 font-medium">Connected Group</p>
                                <div className="w-[400px] pb-2">
                                    <Input value={fyi.name} disabled type="text" />
                                </div>
                                <Button
                                    type="secondary"
                                    size="xs"
                                    label="Edit Mapping"
                                    onClick={(): void => setReplacing(true)}
                                    disabled={!activeSubscription}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div>
        </IntegrationOverview>
    );
}
export default GroupFYIDocsIntegration;
